import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ILabLicense } from "app/models/core/admin/labLicense";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";



@Component({
  selector: 'app-printLabLicense',
  templateUrl: './printLabLicense.component.html',
  styleUrls: ['./printLabLicense.component.scss'],
})

export class PrintLabLicenseComponent implements OnInit {

  editMode = '';
  currentDate = '';
  licenseDate = '';
  type = '';
  stateNumbers = '';

  list: ILabLicense[] = [];

  displayedColumns: string[] = [ 'labName', 'stateNumber', 'cliaNumber', 'cashDate', 'expirationDate',
    'mailingAddress', 'mailingCity', 'mailingState', 'mailingZip', 'director' ];

  dataSource = new MatTableDataSource<ILabLicense>(this.list);

  listFilter = '';

  formGroup = new UntypedFormGroup({
    StateNumbers: new UntypedFormControl(''),
    LicenseDate: new UntypedFormControl(null),
    LicenseType: new UntypedFormControl('', [Validators.required])
  });

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private datePipe: DatePipe) { };

  ngOnInit(): void {
    this.editMode = 'process'
  }

  verify() {
    if (this.formGroup.valid) {
      let form = this.formGroup.value;
      this.currentDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
      this.licenseDate = form.LicenseDate != null ? 
        this.datePipe.transform(form.LicenseDate, 'MM/dd/yyyy'): null;
      this.type = form.LicenseType;
      let typeNumber = this.type == 'HST'? '10': '30';
      this.stateNumbers = form.StateNumbers == ''? null: form.StateNumbers;
      this.adminService.getVerifyLabs(typeNumber, this.licenseDate ,this.stateNumbers ).subscribe(
        res => {
          this.list = res;
          this.editMode = 'list';
          this.dataSource.data = this.list;
          this.timeout();
        },
        error => console.log('error', error),
        () => {
        }
      );
    };
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 500);
  }

  printLicenses(){
    if (!confirm('Are you sure you want to update the date licensed and print licenses for the labs listed? Continue?')) {
      return;
    }
    let form = this.formGroup.value;
    this.type = form.LicenseType;
    let typeNumber = this.type == 'HST'? '10': '30';
    this.adminService.getLabLicensesReport(typeNumber, this.stateNumbers ).subscribe(
      response => {
        this.downloadFile("LabLicenses-" + this.datePipe.transform(new Date(), 'yyyy-MM-dd'), response);
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

  typeChange(){
    this.type = this.formGroup.controls['LicenseType'].value;
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

}
